import React, { useState, useEffect } from 'react'
import { Button } from './ui/button'
import { Input } from './ui/input'
import { toast } from 'react-hot-toast'

const ResetPassword = ({ onSuccess }) => {
  const [token, setToken] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const t = params.get('token')
    if (t) setToken(t)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (password !== confirm) {
      toast.error('Passwörter stimmen nicht überein')
      return
    }
    if (password.length < 8) {
      toast.error('Mindestens 8 Zeichen')
      return
    }
    setLoading(true)
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.detail || 'Fehler')
      setDone(true)
      toast.success('Passwort geändert!')
      setTimeout(() => onSuccess?.(), 2000)
    } catch (err) {
      toast.error(err.message)
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className="text-center text-red-500 p-6">
        Ungültiger Reset-Link. Bitte fordern Sie einen neuen an.
      </div>
    )
  }

  if (done) {
    return (
      <div className="text-center space-y-3 p-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-2">
          <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="font-semibold text-slate-800">Passwort geändert!</p>
        <p className="text-sm text-slate-500">Sie werden zum Login weitergeleitet…</p>
      </div>
    )
  }

  return (
    <div className="space-y-4 max-w-sm mx-auto p-6">
      <div className="text-center mb-4">
        <h3 className="text-xl font-bold text-slate-800">Neues Passwort setzen</h3>
        <p className="text-sm text-slate-500 mt-1">Mindestens 8 Zeichen.</p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input
          type="password"
          placeholder="Neues Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
        />
        <Input
          type="password"
          placeholder="Passwort bestätigen"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <Button
          type="submit"
          disabled={loading || !password || !confirm}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
        >
          {loading ? 'Speichere...' : 'Passwort speichern'}
        </Button>
      </form>
    </div>
  )
}

export default ResetPassword
